import { useState } from 'react'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@mui/material';

const BackdropComponent = ({ open }) => {

    return (
        <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={open}
            // onClick={handleClose}
        >
            <Typography component={'div'} variant='h5'>{"Please Wait still Processing"}</Typography>
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default BackdropComponent